import Image from 'next/image'
import Link from 'next/link'

const IMG_DIMENSIONS: Record<string, undefined | { width?: number; height?: number; className?: string }> = {
  '/bnb.svg': {
    height: 20,
    width: 100,
  },
  '/cross.svg': {
    height: 10,
    width: 10,
  },
  '/deribit-colored.svg': {
    height: 20,
    width: 71,
  },
  '/ethena.svg': {
    height: 20,
    width: 75,
  },
  '/securitize.svg': {
    height: 20,
    width: 100,
  },
  '/ton-wordmark.png': {
    height: 20,
    width: 52,
  },
  '/USDe.svg': {
    height: 20,
    width: 60,
  },
}

export const NewsArticle = ({
  description,
  link,
  logos,
  title,
}: {
  logos: string[]
  title: string
  description: string
  link: string
}) => {
  return (
    <Link href={link} target="_blank" rel="noreferrer" className="flex lg:flex-1 lg:last:col-span-2 xl:last:col-span-1">
      <article className="group rounded-[12px] bg-gradient-to-r from-[#91B3F0]/40 to-[#1f2124] p-[1px]">
        <div className="h-full w-full flex flex-col items-center justify-center gap-2 rounded-[12px] bg-background-accent p-2">
          <div className="relative rounded-[10px] news-article-gradient bg-background-accent flex-1 flex flex-col overflow-hidden">
            <Image
              src="/grid3.png"
              alt="grid"
              fill
              className="absolute top-0 left-0 h-full w-full object-cover opacity-30"
              priority={false}
            />
            <div className="flex flex-col gap-4 py-5 px-6 sm:px-8 flex-1">
              <div className="rounded-full bg-gradient-to-l from-[#322950] to-[#0b0a10] p-[1px] w-fit">
                <div className="flex flex-wrap items-center gap-2.5 rounded-full bg-gradient-to-l from-[#111121] to-[#0B0A10] py-3 pr-5">
                  {logos.map((logo, index) => {
                    const { height, width } = IMG_DIMENSIONS[logo] ?? {}
                    return (
                      <Image
                        key={index}
                        src={logo}
                        alt={logo}
                        width={width ?? 20}
                        height={height ?? 20}
                        className="object-contain"
                      />
                    )
                  })}
                </div>
              </div>
              <h2 className="text-text-primary font-medium text-2xl line-clamp-2 text-ellipsis">{title}</h2>
              <p className="text-text-secondary text-base h-[140px] overflow-hidden text-fade-out grow font-inter">
                {description}
              </p>
              <div className="text-text-primary text-sm font-medium flex items-center gap-2 px-5 py-3 border-2 border-[#242935] group-hover:border-[#384051] ease-in-out rounded-full w-fit cursor-pointer relative transition duration-300">
                <span>Continue Reading</span>
                <Image
                  src="/shared/chevron-right.svg"
                  alt="chevron-right"
                  width={20}
                  height={20}
                  className="h-5 w-5 group-hover:translate-x-1 transition duration-300 ease-in-out"
                />
              </div>
            </div>
          </div>
        </div>
      </article>
    </Link>
  )
}
